module.exports = __webpack_public_path__ + "img/s2-notice.4ea24a03.png";